import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  button: {
    //display: 'block',
    background: '#fff',
    borderRadius: 500,
    fontWeight: 600,
    color: colour.brand.blue,
    padding: 13,
    fontSize: 18,
    border: 0,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    cursor: 'pointer',
    ':hover': {
      background: 'rgba(255,255,255,0.9)'
    }
  }
});
